// 年間成績カレンダーのヒートマップスタッツのカウントアップアニメーション
(function() {
  function easeOutQuad(t) { return t * (2 - t); }

  function animateCount(el, target, duration) {
    var start = 0;
    var startTs = null;
    var d = Math.max(200, parseInt(duration || 800, 10));
    function step(ts) {
      if (!startTs) startTs = ts;
      var progress = Math.min(1, (ts - startTs) / d);
      var eased = easeOutQuad(progress);
      var value = Math.round(start + (target - start) * eased);
      el.textContent = value.toString();
      if (progress < 1) { requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  }

  function init(rootEl) {
    try {
      var root = rootEl || document;
      var nodes = root.querySelectorAll ? root.querySelectorAll('[data-countup]') : [];
      nodes.forEach(function(node) {
        var done = node.dataset.countupDone === '1';
        if (done) return;
        var target = parseInt(node.dataset.target || '0', 10);
        var duration = parseInt(node.dataset.duration || '800', 10);
        node.textContent = '0';
        node.dataset.countupDone = '1';
        animateCount(node, target, duration);
      });
    } catch(e) {
      // no-op
    }
  }

  // expose
  window.initYearStatsBar = init;

  // initial load
  document.addEventListener('turbolinks:load', function() {
    // 月間成績ページと成績シェアの閲覧ページ（/s/:token）のどちらにも年間ヒートマップがある
    if (document.getElementById('year-point-heatmap')) {
      init();
    }
  });
})();


